import React, { useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Badge, Tooltip } from '@material-ui/core';
import { NotificationImportant } from '@material-ui/icons';
import { batch } from 'react-redux';
import { useDispatch, useSelector } from 'src/store';
import {
  initAllNews,
  setUnreadCount,
  setUnreadContestCount,
  setUnreadTrimpoengCount,
  setReadContestNewsIds,
  setReadTrimpoengNewsIds
} from 'src/slices/news';
import useSettings from 'src/hooks/useSettings';
import { common } from 'src/assets/locale';
import useAuth from 'src/hooks/useAuth';

function NewsBadge() {
  const dispatch = useDispatch();
  const { settings } = useSettings();
  const { user } = useAuth();

  const {
    contestNews,
    trimpoengNews,
    unreadCount,
    readContestNewsIds,
    readTrimpoengNewsIds
  } = useSelector(state => state.news);

  const maybeContestId = settings.selectedContest?.id;

  const limit = 10;

  useEffect(() => {
    dispatch(
      initAllNews({
        limit,
        contest: settings.selectedContest
      })
    );
  }, [dispatch, settings]);

  // Load read IDs from localStorage on mount
  useEffect(() => {
    const storedContestIds = JSON.parse(
      localStorage.getItem('readContestNewsIds') || '[]'
    );
    const storedTrimpoengIds = JSON.parse(
      localStorage.getItem('readTrimpoengNewsIds') || '[]'
    );

    batch(() => {
      dispatch(setReadContestNewsIds(storedContestIds));
      dispatch(setReadTrimpoengNewsIds(storedTrimpoengIds));
    });
  }, [dispatch]);

  useEffect(() => {
    // Only show news from the last two weeks as potentially unread
    const twoWeeksAgo = new Date();
    twoWeeksAgo.setDate(twoWeeksAgo.getDate() - 14);

    // Contest news - only for the current contest
    const contestUnread = contestNews.filter(
      n =>
        new Date(n.created_at) > twoWeeksAgo &&
        !readContestNewsIds.includes(n.id)
    ).length;

    // Trimpoeng news - only admin or all types
    const trimpoengUnread = trimpoengNews.filter(
      n =>
        new Date(n.created_at) > twoWeeksAgo &&
        (n.type === 'admin' || n.type === 'all' || user.isRoot) &&
        !readTrimpoengNewsIds.includes(n.id)
    ).length;

    // Update counts
    const totalUnread = contestUnread + trimpoengUnread;
    batch(() => {
      dispatch(setUnreadContestCount(contestUnread));
      dispatch(setUnreadTrimpoengCount(trimpoengUnread));
      dispatch(setUnreadCount(totalUnread));
    });
  }, [
    contestNews,
    trimpoengNews,
    readContestNewsIds,
    readTrimpoengNewsIds,
    dispatch,
    maybeContestId,
    user.isRoot
  ]);

  return (
    <Tooltip title={common.news}>
      <Badge badgeContent={unreadCount} color="error" max={limit - 1}>
        <RouterLink
          to="/app/news"
          style={{
            display: 'flex',
            color: 'inherit',
            textDecoration: 'inherit'
          }}
        >
          <NotificationImportant />
        </RouterLink>
      </Badge>
    </Tooltip>
  );
}

export default NewsBadge;
